import { useEffect, useRef } from 'react';

/** Prevent an old dialog's response from replacing a different target's detail. */
export function usePickerTarget(ids: string[], template = false) {
  const sessionKey = `${template ? 'template' : 'project'}:${[...ids].sort().join(',')}`;
  const activeKey = useRef(sessionKey);
  const mounted = useRef(true);
  activeKey.current = sessionKey;
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  return {
    ids,
    template,
    sessionKey,
    isCurrent: () => mounted.current && activeKey.current === sessionKey,
  };
}
